// import Vue from 'vue';
// import VueRouter from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router'
import Calculator from './components/MyCalculator.vue'
import MyResult from './components/MyResult.vue'
import MyWithdraw from './components/MyWithdraw.vue'
import helloPage from './pages/helloPage.vue'

const routes = [
  {
    path: '/helloPage',
    name: 'helloPage',
    component: helloPage,
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: MyWithdraw,
  },
  {
    path: '/',
    name: 'Calculator',
    component: Calculator,
  },
  {
    path: '/result',
    name: 'MyResult',
    component: MyResult,
    props: (route) => ({
      result: route.query.result ? JSON.parse(route.query.result) : null,
    }),
  },
]

// Create a router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
